import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExamPreparationRoutingModule } from './exam-preparation-routing.module';
import { MatFormFieldModule, MatInputModule, MatSelectModule, MatOptionModule,
    MatTableModule, MatIconModule, MatButtonModule, MatDatepickerModule } from '@angular/material';
import { AssignmentPvbModule } from './assignment-pvb/assignment-pvb.module';
import { RouterModule } from '@angular/router';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { DeterminationAssignmentPvbModule } from './determination-assignment-pvb/determination-assignment-pvb.module';

import { FormsModule } from '@angular/forms';
import { BreadcrumbModule } from '../breadcrumb/breadcrumb.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ExamPreparationRoutingModule,
        MatFormFieldModule,
        MatInputModule,
        AssignmentPvbModule,
        DeterminationAssignmentPvbModule,
        FormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatOptionModule,
        MatTableModule,
        MatIconModule,
        BreadcrumbModule,
        MatButtonModule,
        MatDatepickerModule
    ]
})
export class ExamPreparationModule { }



// WEBPACK FOOTER //
// ./src/app/exam-preparation/exam-preparation.module.ts